module.exports = __webpack_public_path__ + "static/img/user.6d7fbde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user.png
// module id = AGL3
// module chunks = 2